<template>
  <button type="button" class="iconButton" :class="{ compact }">
    <slot />
  </button>
</template>

<script setup lang="ts">
defineProps<{ compact?: boolean }>()
</script>

<style scoped>
/* flex, not inline-flex: inside a block wrapper an inline box would add line-box height. */
.iconButton {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  background: none;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: color var(--duration-fast) var(--ease-out),
              background var(--duration-fast) var(--ease-out);
}
.iconButton.compact { width: 28px; height: 28px; }
.iconButton:hover:not(:disabled) {
  color: var(--color-text-primary);
  background: var(--color-bg-subtle);
}
.iconButton:disabled { opacity: 0.4; cursor: default; }
</style>
